export const noOpFn = (): void => undefined;
